import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { StaticQuery, graphql, Link } from "gatsby"
import { navigate } from '@reach/router';
import Tags from "../components/tags";
import Social from '../components/social';
import DateFormatter from "../components/date-formatter"


class Body extends React.Component {
    render () {
     return (
        <Layout selected='/'>
            <SEO title="Home" description="La porta, nelle storie fantasy, è il luogo dove inizia l’altrove e la metafora più evidente del cambiamento. Attraversare una porta, però, non significa solo muoversi da uno spazio all'altro, ma rappresenta anche un passaggio ideale, ovvero il compiersi di una metamorfosi soggettiva." keywords={[`Creare Mondi`, `Fantasy`, `crearemondi`, 'blog fantasy']} />
            <div
            className="homeContainer"
            >
            <div
                className="articles"
                style={{
                    width:'100%'
                }}
            >
                {this.props.children}
            </div>
            <div className="sidebar">
            <br/>
            <div
                className="social"
            >
                <h4 className='title'>
                SOCIAL
                </h4>
                <Social />
            </div>
                <div>
                <br/>
                <h4 className='title'>
                    TAG
                </h4>
                <Tags />
                </div>
                
            </div>
            </div>
            
        </Layout>
        );
     }
}

export default Body
